import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Modal } from '../ui';

interface DuplicateToolModalProps {
  isOpen: boolean;
  toolName: string;
  isLoading?: boolean;
  onClose: () => void;
  onToolNameChange: (value: string) => void;
  onConfirm: () => void;
}

export const DuplicateToolModal: React.FC<DuplicateToolModalProps> = ({
  isOpen,
  toolName,
  isLoading = false,
  onClose,
  onToolNameChange,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('tools.duplicateModalTitle')}
      size="md"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {t('tools.duplicateModalDescription')}
        </p>
        <Input
          value={toolName}
          onChange={event => onToolNameChange(event.target.value)}
          placeholder={t('tools.duplicateNamePlaceholder')}
          autoFocus
        />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} loading={isLoading} disabled={isLoading}>
            {t('tools.duplicateConfirmButton')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
